module.exports = __webpack_public_path__ + "static/media/beep1sec.b2ab2ed7.mp3";